export function numericRange(range: number): Array<number> {
    return [...Array(range).keys()];
}
